import { v4 as uuidv4 } from 'uuid';
import { JsonFieldType } from '../../../types';
import { ComponentType, type IComponentSchema } from '../../types';
import type { IComponentProps } from './index';

export const generate = (
  props?: Partial<IComponentSchema<IComponentProps>>
): IComponentSchema<IComponentProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Custom Panel',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.CompareWorkspaceCustomPanel,
    'x-component-props': {
      header: 'Custom Panel',
    },
    'x-component-props-config': {
      header: { type: 'value' },
    },
    properties: {},
  };
};
